module.exports = __webpack_public_path__ + "static/media/starlla2.11a3b9a7.jpg";